export enum EmptyStateTextOnlySize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
